module.exports = __webpack_public_path__ + "img/loading.3e2e1f1.gif";